import { render, staticRenderFns } from "./ClaimDetail.vue?vue&type=template&id=50738061&scoped=true"
import script from "./ClaimDetail.vue?vue&type=script&lang=js"
export * from "./ClaimDetail.vue?vue&type=script&lang=js"
import style0 from "./ClaimDetail.vue?vue&type=style&index=0&id=50738061&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50738061",
  null
  
)

export default component.exports